import { useSelector } from "react-redux";

import { selectAuthAccessToken } from "../../../../components/src/app-main/selectors/auth.selectors";
import { selectProfileSSOid } from "../../../../components/src/app-main/selectors/profile.selectors";
import { useGetSpaceQuery } from "../../../../components/src/services/spaces.service";
import {
  SpaceEditorLayout,
  SpaceEditorLayoutSkeleton,
} from "../components/SpaceEditorLayout";

import { ArrivalGuideForm } from "./ArrivalGuideForm";

type ArrivalGuidePageProps = {
  params: { spaceId: string };
};

const ArrivalGuidePage = ({ params: { spaceId } }: ArrivalGuidePageProps) => {
  const accessToken = useSelector(selectAuthAccessToken);
  const ssoId = useSelector(selectProfileSSOid);
  const { data: space, isFetching } = useGetSpaceQuery({ spaceId });

  if (!accessToken) {
    return null;
  }

  const isLoading = isFetching || !space || !ssoId;

  // Ensure only space owners can access this page
  if (!isLoading && space.ownerId !== ssoId) {
    window.location.href = "/mylistings";
    return null;
  }

  return (
    <div
      className="ps-container-lg-margin ps-container-fixed"
      data-testid="arrival-guide-page"
    >
      <div className="ps-row">
        <div className="col-xs-12">
          {isLoading ? (
            <SpaceEditorLayoutSkeleton />
          ) : (
            <SpaceEditorLayout space={space}>
              <ArrivalGuideForm space={space} />
            </SpaceEditorLayout>
          )}
        </div>
      </div>
    </div>
  );
};

export { ArrivalGuidePage };
